module.exports = "//static.hsappstatic.net/salesImages/static-1.403/react-telephone-input/flags.png"